// ACTION TYPES
const name = 'params';
export const actionTypes = {
  SET_TICKER: `${name}:set_chart_param`,
  SET_CHART_TICKER: `${name}:set_chart_ticker`,
  SET_CHART_TYPE: `${name}:set_chart_type`,
};

// ACTIONS
export function setChartParam(param) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_TICKER, value: param });
  };
}

export function setChartTicker(param) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_TICKER, value: param });
  };
}

export function setChartType(param) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_CHART_TYPE, value: param });
  };
}




// WEBPACK FOOTER //
// ./src/actions/params.js